/* eslint-disable */
import { useState } from "react";
import TableBody from "./components/TableBody";
import TableHead from "./components/TableHead";
import { TableX } from "./styles";

const tableData1 = [
  {
    id: 1,
    nome_agenda: "Agenda 10/02/2023",
    local: "Jardim Europa",
    dia_semana: "Sexta-Feira",
    turno: "Tarde",
    acao: "Cancelou reserva",
    hora_acao: "10/02/2023 08:36:80",
  },
  {
    id: 2,
    nome_agenda: "Agenda 10/02/2023",
    local: "Jardim Europa",
    dia_semana: "Sexta-Feira",
    turno: "Tarde",
    acao: "Confirmou reserva",
    hora_acao: "10/02/2023 08:36:00",
  },
  {
    id: 3,
    nome_agenda: "Agenda 10/02/2023",
    local: "Jardim Europa",
    dia_semana: "Sexta-Feira",
    turno: "Tarde",
    acao: "Pré reservou posição",
    hora_acao: "10/02/2023 08:35:00",
  },
  {
    id: 4,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Quarta-Feira",
    turno: "Manhã",
    acao: "Cancelou pré reserva",
    hora_acao: "10/02/2023 08:34:80",
  },
  {
    id: 5,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Quarta-Feira",
    turno: "Manhã",
    acao: "Pré reservou posição",
    hora_acao: "10/02/2023 08:34:15",
  },
  {
    id: 6,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Sexta-Feira",
    turno: "Tarde",
    acao: "Cancelou reserva",
    hora_acao: "10/02/2023 08:32:00",
  },
  {
    id: 7,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Segunda-Feira",
    turno: "Tarde",
    acao: "Confirmou posição",
    hora_acao: "10/02/2023 08:31:25",
  },
  {
    id: 8,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Segunda-Feira",
    turno: "Manhã",
    acao: "Confirmou posição",
    hora_acao: "10/02/2023 08:31:25",
  },
  {
    id: 9,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Segunda-Feira",
    turno: "Tarde",
    acao: "Pré reservou posição",
    hora_acao: "10/02/2023 08:30:60",
  },
  {
    id: 10,
    nome_agenda: "Agenda 10/02/2023",
    local: "Atmosfera",
    dia_semana: "Segunda-Feira",
    turno: "Manhã",
    acao: "Pré reservou posição",
    hora_acao: "10/02/2023 08:30:00",
  },
];

const Table = ({ data }: any) => {
  const [tableData, setTableData] = useState(tableData1);
  const columns = [
    { label: "Nome agenda", accessor: "nome_agenda" },
    { label: "Local", accessor: "local" },
    { label: "Dia da semana", accessor: "dia_semana" },
    { label: "Turno", accessor: "turno" },
    { label: "Ação", accessor: "acao" },
    { label: "Tipo de cancelamento", accessor: "tipoCancelamentoPreReserva" },
    { label: "Hora ação", accessor: "hora_acao" },
  ];

  return (
    <>
      <TableX>
        <TableHead columns={columns} />
        <TableBody columns={columns} tableData={data} />
      </TableX>
    </>
  );
};

export default Table;
